import { createSelector } from 'reselect';
import { RootState } from 'src/store/storeManager';

const getSceneLinks = (state: RootState) => state.sceneConfiguration.links;

const getLinks = createSelector([getSceneLinks], (links) => links);

export default getLinks;
